import { observer } from 'mobx-react';
import React from 'react';
import { promocodeStore } from '../../store/promocodeStore';
import { TBooleanInNumber } from 'src/types/main';
import { booleanToNumber } from 'src/utils/helpers';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import { InputWithTextInside } from '~/view/components/Controls/Inputs';
import Text from '~/view/components/Text/Text';
import './style.scss';
import ReoccurringUsageLimits from '~/view/screens/MarketingScreen/screens/PromocodesScreen/components/ReoccurringUsageLimits/ReoccurringUsageLimits';

@observer
export default class PromocodeConditions extends React.Component<{}, {}> {
  onChangeFirstOrder = (data: TBooleanInNumber) => {
    promocodeStore.changePromocode({ first_order: Boolean(data) });
  };

  onChangeFreeDelivery = (data: TBooleanInNumber) => {
    promocodeStore.changePromocode({ is_free_delivery: Boolean(data) });
  };

  onChangeUsageLimited = (value: string | undefined) => {
    promocodeStore.changePromocode({ usage_limited: value ? Number(value) : 0 });
  };

  onChangeUsagePerCustomer = (value: string | undefined) => {
    promocodeStore.changePromocode({ user_limited: value ? Number(value) : 0 });
  };

  render() {
    return (
      <div className="mt-4">
        <Text type="block-header" text="conditions" />

        <div className="d-flex flex-row mt-3 gap-20">
          <div className="d-flex flex-row align-items-center promocode-conditions__switcher-field">
            <Switcher
              status={promocodeStore.promocode.first_order ? booleanToNumber(promocodeStore.promocode.first_order) : 0}
              onChange={this.onChangeFirstOrder}
            />
            <Text type="switcher-label" text="apply_to_first_order_only" />
          </div>
        </div>

        <div className="d-flex flex-row mt-4 gap-10">
          <InputWithTextInside
            type="number"
            value={promocodeStore.promocode.usage_limited}
            onChangeValue={this.onChangeUsageLimited}
            textProps={{ text: 'total_usage_limit' }}
            maxLength={5}
            contentClassName="promocode-conditions__input promocode_large_field"
          />
        </div>

        <div className="d-flex flex-row mt-4 gap-20">
          <div className="d-flex flex-row align-items-center promocode-conditions__switcher-field">
            <Switcher
              status={promocodeStore.promocode.is_free_delivery ? booleanToNumber(promocodeStore.promocode.is_free_delivery) : 0}
              onChange={this.onChangeFreeDelivery}
            />
            <Text type="switcher-label" text="include_free_delivery" />
          </div>
        </div>

        <div className="d-flex flex-row mt-4 gap-10">
          <InputWithTextInside
            type="number"
            value={promocodeStore.promocode.user_limited}
            onChangeValue={this.onChangeUsagePerCustomer}
            textProps={{ text: 'usage_per_customer' }}
            maxLength={5}
            contentClassName="promocode-conditions__input_large"
          />
        </div>
        <ReoccurringUsageLimits />
      </div>
    );
  }
}
